import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { ContractState } from './state';

const defaultState: ContractState = {
  contracts: [],
};

export const contractModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
